var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmotiiVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 5.16732H4.66699V11.834H3.33366V5.16732ZM0.666992 7.16732H2.00033V9.83398H0.666992V7.16732ZM6.00033 1.83398H7.33366V13.834H6.00033V1.83398ZM8.66699 3.16732H10.0003V15.1673H8.66699V3.16732ZM11.3337 5.16732H12.667V11.834H11.3337V5.16732ZM14.0003 7.16732H15.3337V9.83398H14.0003V7.16732Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotiiVoice);
export default __webpack_public_path__ + "static/media/emotiiVoice.fefec2944bc871877da07350a78a5d41.svg";
export { ForwardRef as ReactComponent };